// extracted by mini-css-extract-plugin
module.exports = {"commentBlock":"styles_commentBlock__3yxZV","newComment":"styles_newComment__2XOSL","expandVertically":"styles_expandVertically__fHy3d"};